import type { Locale } from 'date-fns';
import type { CALENDAR_WEEK_STARTS_ON } from '@studio/constants/calendar';

const getWeekStartLocale = (locale: Locale, weekStartsOn: CALENDAR_WEEK_STARTS_ON) => ({
  ...locale,
  options: {
    ...locale.options,
    weekStartsOn,
  },
});

export default getWeekStartLocale;
